import {
  ReconciliationReportType,
  ReportWebService,
  RestfulReportWebService
} from 'ws/ReportWebService';

import { ReportType, ReportDimension, ReportGran, ReportData, ECConvDays } from './ReportData';

export interface ReportManager {
  downloadL1ObjectReport (order: {
    name: string,
    l1ObjectId: number
  }, startDate: string, endDate: string, groupBy: string, selectFields: string[]): Promise<void>;
  getReportData (type: ReportType, dimension: ReportDimension, gran: ReportGran, filter: any, from: string, to: string, ecConvDays?: ECConvDays): Promise<ReportData>;
  downloadTenmaxReconciliationReport (reportType: ReconciliationReportType, from: string, to: string): Promise<void>;
  downloadStoredValueReconciliationReport (from: string, to: string): Promise<void>;
}

export class DefaultReportManager implements ReportManager {
  webService: ReportWebService;

  constructor (
    webService: ReportWebService = new RestfulReportWebService()
  ) {
    this.webService = webService;
  }
  async downloadL1ObjectReport (l1Object: {
    name: string,
    l1ObjectId: number
  }, startDate: string, endDate: string, groupBy: string, selectFields: string[]): Promise<void> {
    await this.webService.downloadL1ObjectReport(l1Object, startDate, endDate, groupBy, selectFields);
  }
  async getReportData (type: ReportType, dimension: ReportDimension, gran: ReportGran, filter: any, from: string, to: string, ecConvDays?: ECConvDays) {
    return this.webService.getReportData(type, dimension, gran, filter, from, to, ecConvDays);
  }
  async downloadTenmaxReconciliationReport (reportType: ReconciliationReportType, from: string, to: string): Promise<void> {
    await this.webService.downloadTenmaxReconciliationReport(reportType, from, to);
  }
  async downloadStoredValueReconciliationReport (from: string, to: string): Promise<void> {
    await this.webService.downloadStoredValueReconciliationReport(from, to);
  }
}
